<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.41,8C9.41,8,12.7,4.71,12.7,4.71C12.89,4.53,13,4.28,13,4C13,3.45,12.55,3,12,3C11.72,3,11.47,3.11,11.29,3.29C11.29,3.29,8,6.59,8,6.59C8,6.59,4.71,3.29,4.71,3.29C4.53,3.11,4.28,3,4,3C3.45,3,3,3.45,3,4C3,4.28,3.11,4.53,3.29,4.71C3.29,4.71,6.59,8,6.59,8C6.59,8,3.3,11.29,3.3,11.29C3.11,11.47,3,11.72,3,12C3,12.55,3.45,13,4,13C4.28,13,4.53,12.89,4.71,12.71C4.71,12.71,8,9.41,8,9.41C8,9.41,11.29,12.7,11.29,12.7C11.47,12.89,11.72,13,12,13C12.55,13,13,12.55,13,12C13,11.72,12.89,11.47,12.71,11.29C12.71,11.29,9.41,8,9.41,8C9.41,8,9.41,8,9.41,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Cross',
} as DefineComponent
</script>
